import mime from 'mime-types';
import axios from '../config/axios';
import {actions as A} from '../constants/actions';
import {setRequestId} from '../utils/setRequestId';

export const uploadIdFile = ({
                               fileTypeId,
                               file,
                               firstName,
                               lastName,
                               idNumber,
                               nationality
                             }) => {
  return (dispatch) => {
    const formData = new FormData();
    formData.append('fileType', fileTypeId);
    formData.append('fileExtension', mime.extension(file.type));
    formData.append('content', file);
    formData.append('firstName', firstName);
    formData.append('lastName', lastName);
    formData.append('idNumber', idNumber);
    formData.append('nationality', nationality);

    dispatch({type: A.UPLOAD_ID_FILE});
    setRequestId();

    return axios.post(`/regGeneral/uploadFile`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then((result) => {
        dispatch({type: A.UPLOAD_ID_FILE_SUCCESS});
        const {data} = result.data;
        return data && data?.details ? data?.details : null;
      })
      .catch((err) => {
        return dispatch({
          type: A.UPLOAD_ID_FILE_FAILURE,
          payload: {message: err.message}
        });
      });
  };
};
